import * as React from 'react';
export const IcCropPlanningStyle2 = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.64 16.32a1 1 0 00-.82-.21 6.08 6.08 0 00-1.46.48l-.36.15v-2.86a4.23 4.23 0 003-3.29.481.481 0 00-.11-.41.49.49 0 00-.39-.18 3.82 3.82 0 00-2.5.86v-2a4.23 4.23 0 003-3.29.481.481 0 00-.11-.41.49.49 0 00-.39-.16 3.82 3.82 0 00-2.5.86V4a1 1 0 00-2 0v1.86A3.82 3.82 0 0013.5 5a.49.49 0 00-.38.18.48.48 0 00-.11.41 4.23 4.23 0 003 3.29v2A3.82 3.82 0 0013.5 10a.49.49 0 00-.38.18.48.48 0 00-.11.41 4.23 4.23 0 003 3.29V17a3.91 3.91 0 01-1.35-.38A5.66 5.66 0 0012 16a5.67 5.67 0 00-2.66.59A3.79 3.79 0 018 17v-2.12a4.23 4.23 0 003-3.29.481.481 0 00-.11-.41.49.49 0 00-.39-.18 3.82 3.82 0 00-2.5.86v-2a4.23 4.23 0 003-3.29.481.481 0 00-.11-.41.49.49 0 00-.39-.16 3.82 3.82 0 00-2.5.86V5a1 1 0 10-2 0v1.86A3.82 3.82 0 003.5 6a.49.49 0 00-.38.18.48.48 0 00-.12.41 4.23 4.23 0 003 3.29v2A3.82 3.82 0 003.5 11a.489.489 0 00-.38.18.48.48 0 00-.11.41 4.23 4.23 0 003 3.29v1.86l-.37-.15a6.002 6.002 0 00-1.45-.48 1 1 0 00-.82.21 1 1 0 00-.36.77V20a1 1 0 001 1H20a1 1 0 001-1v-2.91a1.001 1.001 0 00-.36-.77z'
      fill='currentColor'
    />
  </svg>
);
